<template>
  <div class="card mg-10px">
    <div class="card-content">
      <div class="columns is-multiline">
        <div class="column is-12 columns is-marginless is-paddingless">
          <div class="column is-narrow pdr-0 pdl-0">
            <b-icon icon="drag" class="mgt-2px draggable-handle">
            </b-icon>
          </div>
          <div class="column is-narrow pdr-0 pdl-0 mgl-3px">
            <b-checkbox class="mgt-3px"></b-checkbox>
          </div>
          <div class="column pdb-0 pdl-0">
           <p class="has-text-link is-size-6 has-text-weight-bold">
            <router-link-blank :to="{
              name: 'c.bodac.clients/contacts-client',
              params: { id: ligne.annonceurId }
            }" :message="ligne.annonceur" class="is-inline">
            </router-link-blank>
           </p>
          </div>
        </div>
        <div class="column is-12 is-paddingless">
          <p class="has-text-link is-size-6 has-text-weight-bold">
            <router-link-blank :to="{
              name: 'c.bodac.commandes',
              params: { id: ligne.devisCommandeId }
            }" :message="ligne.codeDevisCommande" class="is-inline">
            </router-link-blank>
            <span v-if="ligne.planMediaId && modulePlanMediaActive"> - </span>
            <router-link-blank v-if="ligne.planMediaId && modulePlanMediaActive"
              :to="{
                name: 'c.presse.plan_media',
                params: { id: ligne.planMediaId }
              }"
              :message="ligne.codePlanMedia" class="is-inline">
            </router-link-blank>
          </p>
        </div>
      </div>
      <div class="columns is-multiline">
        <div class="column is-12 is-paddingless pdt-5px is-size-7">
          <p>
            <span class="has-text-weight-semibold">
              {{ $t('editBat.card.parution') }}
            </span>
            {{ ligne.lignePresse.libelle }}
          </p>
        </div>
        <div class="column is-12 is-paddingless pdt-5px is-size-7">
          <p>
            <span class="has-text-weight-semibold">
              {{ $t('editBat.card.encart') }}
            </span>
            <span v-html="formatBackToLineHtml(ligne.ligneEncart.libelle)"></span>
          </p>
        </div>
      </div>
      <div class="columns is-multiline">
        <div class="column is-paddingless pdt-5px is-12 ">
          <b-icon
            :icon="ligne.lignePresse.visuelDemande ?
              'check-circle-outline' : 'close-circle-outline'"
            :type="ligne.lignePresse.visuelDemande?
              'is-success' : 'is-warning'"
            class="is-vertical-middle">
          </b-icon>
          <span class="is-size-7 is-vertical-middle pdl-5px pdr-5px">
            {{ $t('editBat.card.visuelDemande') }}
            <span v-if="ligne.lignePresse.dateDemandeVisuel">
              ( {{ formatDate(ligne.lignePresse.dateDemandeVisuel)}} )
            </span>
          </span>
        </div>

        <div class="column is-paddingless pdt-5px is-12 ">
          <b-icon
            :icon="ligne.lignePresse.afficheLivre ?
              'check-circle-outline': 'close-circle-outline'"
            :type="ligne.lignePresse.afficheLivre ?
              'is-success' : 'is-warning'"
            class="is-vertical-middle">
          </b-icon>
          <span class="is-size-7 is-vertical-middle pdl-5px pdr-5px">
            {{ $t('editBat.card.visuelRecu') }}
            <span v-if="ligne.lignePresse.dateTransmisPAO">
              ( {{ formatDate(ligne.lignePresse.dateTransmisPAO)}} )
            </span>
          </span>
        </div>

        <div class="column is-paddingless pdt-5px is-12">
          <b-icon
            :icon="ligne.lignePresse.dateTransmisPAO ?
              'check-circle-outline' : 'close-circle-outline'"
            :type="ligne.lignePresse.dateTransmisPAO ?
              'is-success' : 'is-warning'"
            class="is-vertical-middle">
          </b-icon>
          <span class="is-size-7 is-vertical-middle pdl-5px pdr-5px">
            {{ $t('editBat.card.transmisPAO') }}
            <span v-if="ligne.lignePresse.dateTransmisPAO">
              ( {{ formatDate(ligne.lignePresse.dateTransmisPAO)}} )
            </span>
          </span>
        </div>

        <div class="column is-paddingless pdt-5px is-12">
          <b-icon
            :icon="ligne.lignePresse.dateValidationVRP ?
              'check-circle-outline' : 'close-circle-outline'"
            :type="ligne.lignePresse.dateValidationVRP ?
              'is-success' : 'is-warning'"
            class="is-vertical-middle">
          </b-icon>
          <span class="is-size-7 is-vertical-middle pdl-5px pdr-5px">
            {{ $t('editBat.card.validationVRP') }}
            <span v-if="ligne.lignePresse.dateValidationVRP">
              ( {{ formatDate(ligne.lignePresse.dateValidationVRP)}} )
            </span>
          </span>
        </div>

        <div class="column is-paddingless pdt-5px is-12">
          <b-icon
            :icon="ligne.lignePresse.dateEnvoiBat ?
              'check-circle-outline' : 'close-circle-outline'"
            :type="ligne.lignePresse.dateEnvoiBat ?
              'is-success' : 'is-warning'"
            class="is-vertical-middle">
          </b-icon>
          <span class="is-size-7 is-vertical-middle pdl-5px pdr-5px">
            {{ $t('editBat.card.envoiBAT') }}
            <span v-if="ligne.lignePresse.dateEnvoiBat">
              ( {{ formatDate(ligne.lignePresse.dateEnvoiBat)}} )
            </span>
          </span>
        </div>

        <div class="column is-paddingless pdt-5px is-12">
          <b-icon
            :icon="ligne.lignePresse.batDemande ?
              'check-circle-outline' : 'close-circle-outline'"
            :type="ligne.lignePresse.batDemande ?
              'is-success' : 'is-warning'"
            class="is-vertical-middle">
          </b-icon>
          <span class="is-size-7 is-vertical-middle pdl-5px pdr-5px">
            {{ $t('editBat.card.batDemande') }}
            <span v-if="ligne.lignePresse.dateBatDemande && ligne.lignePresse.batDemande">
              ( {{ formatDate(ligne.lignePresse.dateBatDemande)}} )
            </span>
          </span>
        </div>

        <div class="column is-paddingless pdt-5px is-12">
          <b-icon
            :icon="ligne.lignePresse.batRecu ?
              'check-circle-outline' : 'close-circle-outline'"
            :type="ligne.lignePresse.batRecu ?
              'is-success' : 'is-warning'"
            class="is-vertical-middle">
          </b-icon>
          <span class="is-size-7 is-vertical-middle pdl-5px pdr-5px">
            {{ $t('editBat.card.batRecu') }}
            <span v-if="ligne.lignePresse.dateBatRecu && ligne.lignePresse.batRecu">
              ( {{ formatDate(ligne.lignePresse.dateBatRecu)}} )
            </span>
          </span>
        </div>

      </div>
      <div class="columns is-multiline">
        <div v-if="ligne.lignePresse.dateAccord" class="column is-12 pd-5px is-size-7">
          <p class="ellipsis-two-line">
            <span class="has-text-weight-semibold">
              {{ $t('editBat.card.dateAccord') }}
            </span>
            <span> {{ ligne.lignePresse.dateAccord | formatDate }} </span>
          </p>
        </div>
        <div v-else class="column is-12 pd-5px is-size-7">
          <p class="ellipsis-two-line"><br/></p>
        </div>
        <div v-if="ligne.lignePresse.commentaireAccord" class="column is-12 pd-5px is-size-7">
          <p class="ellipsis-two-line">
            <span class="has-text-weight-semibold">
              {{ $t('editBat.card.commentaire') }}
            </span>‡
            <span> {{ ligne.lignePresse.commentaireAccord }} </span>
          </p>
        </div>
      </div>
    </div>
    <footer class="card-footer columns is-marginless is-justify-content-space-between">
      <div class="column is-narrow py-0 pl-0">
        <button
          class="button is-white is-fullwidth"
          :class="{ disabled: columnIndex <= 0 }"
          @click="$emit('moveCard', ligne, columnIndex - 1)">
          <b-icon type="is-primary" icon="arrow-left-bold-circle"/>
        </button>
      </div>
      <div v-if="sendEmail" class="column p-0">
        <button
          class="button is-white is-fullwidth"
          @click="openPopUpEmail">
          <b-icon class="mgr-2" type="is-primary" icon="email-plus"/>
          <b-tooltip
            :label="$t('editBat.card.envoyerDemande')"
            type="is-primary"
            multiline>
            <span class="ellipsis is-cursor-pointer">
              {{ $t('editBat.card.envoyer') }}
            </span>
          </b-tooltip>
        </button>
      </div>
      <div class="column is-narrow py-0 pr-0">
        <button
          class="button is-white is-fullwidth"
          :class="{ disabled: columnIndex >= (columnsLength - 1) }"
          @click="$emit('moveCard', ligne, columnIndex + 1)">
          <b-icon type="is-primary" icon="arrow-right-bold-circle"/>
        </button>
      </div>
    </footer>
    <b-modal v-model="popUpMail" has-modal-card class="modal">
      <pop-up-mail :mail="mail" :contacts="contacts"
      :error="errorEmail" :editionsAInclure="editionsAInclure"
        @addContact="getTextEmail" @sendEmail="envoieMail()" title="editBat.card.popUpMail.title">
      </pop-up-mail>
    </b-modal>
  </div>
</template>

<script>
import { createNamespacedHelpers } from 'vuex';
import formatDate from '@/services/general/formatDate';
import messageErreur from '@/services/general/messageErreur';
import messageSucces from '@/services/general/messageSucces';
import genererMail from '@/services/general/genererMail';
import { convertUserToMail } from '@/services/dcf/generationMail';
import validationEnvoieMail from '@/services/general/validation/validationEnvoieMail';
import envoieMailBat from '@/services/presse/parution/envoieMailBat';
import routerLinkBlank from '@/components/general/routerLinkBlank';
import { COMMERCIAL, DIRECTEUR_COMMERCIAL } from '@/configuration/parametrage/utilisateurConf';
import { PARAMETRES_KEYS, PARAMETRES_INTERNE_KEYS } from '@/store/modules/parametres-mutation-type';
import popUpMail from '@/components/general/p_mail';
import {
  DEMANDE_VISUEL,
  ENVOIE_BAT,
  ATTENTE_RETOUR_BAT,
  TRANSMI_PAO,
  VALIDATION_VRP,
} from '@/configuration/presse/produitPresse/produitPresseConf';
import { getTexteEmailByEtatBatAsync } from '@/api/presse/parution';
import getInfoContacts from '@/services/general/mail/getInfoContactsMail';
import formatBackToLineHtml from '@/services/general/formatBackToLineHtml';
import {
  updateLigneCommandePresseVisuelDemande, updateLogistiquePresse,
} from '@/api/ligneCommande';

const Societe = createNamespacedHelpers('societe');
const User = createNamespacedHelpers('user');
const Permissions = createNamespacedHelpers('permissions');
const Parametres = createNamespacedHelpers('parametres');

export default {
  props: {
    ligne: {
      type: Object,
      required: true,
    },
    etatBat: {
      type: String,
      required: true,
    },
    columnIndex: {
      type: Number,
    },
    columnsLength: {
      type: Number,
    },
    parution: {
      type: Object,
    },
    ajouterBATdansMail: {
      type: Boolean,
      required: false,
      default: true,
    },
  },
  components: {
    routerLinkBlank,
    popUpMail,
  },
  data() {
    return {
      popUpMail: false,
      mail: null,
      users: [],
      contacts: [],
      editionsAInclure: [{ libelle: 'editBat.card.popUpMail.inclureBat', key: 'mettreEdition', value: true }],
      errorEmail: {
        haveError: false,
        messages: [],
      },
      formatBackToLineHtml,
    };
  },
  computed: {
    ...Societe.mapGetters({
      societeActiveId: 'societeActiveId',
    }),
    ...Parametres.mapGetters({
      parametre: 'parametre',
      parametresInterne: 'parametresInterne',
    }),
    ...User.mapGetters({
      user: 'user',
    }),
    ...Permissions.mapGetters({
      userAffixe1: 'userAffixe1',
    }),
    sendEmail() {
      return [DEMANDE_VISUEL, ENVOIE_BAT, TRANSMI_PAO, VALIDATION_VRP, null].includes(this.etatBat);
    },
    modulePlanMediaActive() {
      return this.parametresInterne(PARAMETRES_INTERNE_KEYS.modulePlanMedia.key);
    },
  },
  methods: {
    ...Parametres.mapActions({
      loadParametreUtilisateur: 'loadParametreUtilisateur',
      loadParametresInterne: 'loadParametresInterne',
    }),
    formatDate(date) {
      return formatDate(date);
    },
    async getTextEmail(contact) {
      if (![DEMANDE_VISUEL, ENVOIE_BAT, TRANSMI_PAO, VALIDATION_VRP].includes(this.etatBat)) return;
      const loadingComponent = this.$buefy.loading.open();
      try {
        this.mail.corps = (await getTexteEmailByEtatBatAsync({
          ligneCommandeId: this.ligne.lignePresse.id,
          contactId: contact ? contact.id : null,
          etatBat: this.etatBat,
        })).data.result;
        loadingComponent.close();
      } catch (e) {
        messageErreur(this.$i18n);
        loadingComponent.close();
        throw e;
      }
    },
    async openPopUpEmail() {
      const loadingComponent = this.$buefy.loading.open();
      try {
        if (!this.sendEmail) return;
        this.contacts = await getInfoContacts(this.ligne?.intervenants, this.$t('editBat.card.popUpMail.contactTitle'));
        this.errorEmail.messages = [];
        this.errorEmail.haveError = false;
        const mail = genererMail();
        if (this.ligne.commercialId) {
          const commerciaux = this.users.filter((user) => {
            return user.profil === COMMERCIAL || user.profil === DIRECTEUR_COMMERCIAL;
          });
          const commercial = await commerciaux.find((commercial) => {
            return commercial.id === this.ligne.commercialId;
          });
          if (commercial && commercial.email) {
            if (this.etatBat === TRANSMI_PAO) mail.to.push(convertUserToMail(commercial));
            else mail.cc.push(convertUserToMail(commercial));
          }
        }
        if (this.user.email) {
          mail.from = this.user.email;
          if (!this.userAffixe1 && !mail.cc.map(c => c.email).includes(this.user.email)) {
            mail.cci.push(convertUserToMail(this.user));
          }
        }
        if (mail.to) {
          mail.corps = (await getTexteEmailByEtatBatAsync({
            ligneCommandeId: this.ligne.lignePresse.id,
            contactId: this.ligne.contactId,
            etatBat: this.etatBat,
          })).data.result;
        }
        switch (this.etatBat) {
          case ENVOIE_BAT: {
            mail.objet = 'BAT - ' + this.ligne.lignePresse.libelle + ' - ' + this.parution.nomParution + ' - N° ' + this.parution.numParution;
            this.editionsAInclure.find(e => e.key === 'mettreEdition').value = this.ajouterBATdansMail;
            break;
          }
          case TRANSMI_PAO: {
            mail.objet = 'TRANSMIS PAO - ' + this.ligne.annonceur + ' - ' + this.ligne.lignePresse.libelle + ' - ' + this.parution.nomParution + ' - N° ' + this.parution.numParution;
            this.editionsAInclure[0].value = this.ajouterBATdansMail;
            break;
          }
          case DEMANDE_VISUEL: {
            mail.objet = 'DEMANDE VISUEL - ' + this.ligne.lignePresse.libelle + ' - ' + this.parution.nomParution + ' - N° ' + this.parution.numParution;
            this.editionsAInclure[0].value = false;
            break;
          }
          default: {
            this.editionsAInclure[0].value = this.ajouterBATdansMail;
            break;
          }
        }

        this.mail = mail;
        this.popUpMail = true;
        loadingComponent.close();
      } catch (e) {
        messageErreur(this.$i18n);
        loadingComponent.close();
        throw e;
      }
    },
    async envoieMail() {
      const loadingComponent = this.$buefy.loading.open();
      try {
        this.errorEmail.messages = [];
        this.errorEmail.haveError = false;
        await envoieMailBat(
          this.mail,
          this.editionsAInclure[0].value,
          this.societeActiveId,
          this.ligne.id,
        );
        messageSucces(this.$i18n.t('mail.success.envoie'));
        this.popUpMail = false;
        if (this.etatBat === DEMANDE_VISUEL) {
          await updateLigneCommandePresseVisuelDemande({
            ligneCommandeId: this.ligne.lignePresse.id,
            visuelDemande: true,
          });
        }
        if (this.etatBat === ENVOIE_BAT) {
          await updateLogistiquePresse({
            ligneCommandeIds: [this.ligne.lignePresse.id],
            etatBat: ATTENTE_RETOUR_BAT,
            accordTelephonique: false,
            commentaireAccord: null,
            dateAccord: null,
          });
        }
        if (this.etatBat === TRANSMI_PAO) {
          await updateLogistiquePresse({
            ligneCommandeIds: [this.ligne.lignePresse.id],
            etatBat: VALIDATION_VRP,
            accordTelephonique: false,
            commentaireAccord: null,
            dateAccord: null,
          });
        }
        this.$emit('refresh');
        loadingComponent.close();
      } catch (e) {
        if (e.response.data.error) {
          validationEnvoieMail(e.response, this.errorEmail.messages);
          this.errorEmail.haveError = true;
        } else messageErreur(this.$i18n);
        loadingComponent.close();
        throw (e);
      }
    },
  },
  async mounted() {
    await this.loadParametreUtilisateur();
    await this.loadParametresInterne([PARAMETRES_INTERNE_KEYS.modulePlanMedia.key]);
    this.users = this.parametre(PARAMETRES_KEYS.utilisateur);
  },
};
</script>
